var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "drug-info-page" },
    [
      _c(
        "div",
        { staticClass: "drug-list" },
        _vm._l(_vm.drugList, function (drug) {
          return _c(
            "div",
            {
              key: drug.id,
              staticClass: "drug-card",
              on: {
                click: function ($event) {
                  return _vm.showDrugDetails(drug)
                },
              },
            },
            [
              _c("div", { staticClass: "drug-img-container" }, [
                _c("img", {
                  staticClass: "drug-img",
                  attrs: { src: drug.imageUrl, alt: drug.name },
                }),
              ]),
              _c("div", { staticClass: "drug-info" }, [
                _c("div", { staticClass: "drug-name" }, [
                  _vm._v(_vm._s(drug.name)),
                ]),
              ]),
              _c("div", { staticStyle: { "text-align": "center" } }, [
                _c(
                  "button",
                  {
                    staticClass: "view-detail-btn",
                    on: {
                      click: function ($event) {
                        $event.stopPropagation()
                        return _vm.showDrugDetails(drug)
                      },
                    },
                  },
                  [_vm._v("\n          查看详情\n        ")]
                ),
              ]),
            ]
          )
        }),
        0
      ),
      _c(
        "el-dialog",
        {
          attrs: {
            title: "药品详情",
            visible: _vm.dialogVisible,
            width: "70%",
            top: "3vh",
            "close-on-click-modal": false,
            "custom-class": "drug-detail-dialog",
          },
          on: {
            "update:visible": function ($event) {
              _vm.dialogVisible = $event
            },
          },
        },
        [
          _c("div", { staticClass: "drug-detail-content" }, [
            _c("div", { staticClass: "detail-header" }, [
              _c("img", {
                staticClass: "detail-img",
                attrs: {
                  src: _vm.selectedDrug.imageUrl,
                  alt: _vm.selectedDrug.name,
                },
              }),
              _c(
                "div",
                { staticStyle: { width: "600px", "text-align": "center" } },
                [
                  _c("h3", { staticClass: "detail-title" }, [
                    _vm._v(_vm._s(_vm.selectedDrug.fullName)),
                  ]),
                ]
              ),
            ]),
          ]),
          _c("div", { staticClass: "detail-info-list" }, [
            _c("div", {
              domProps: { innerHTML: _vm._s(_vm.selectedDrug.content) },
            }),
          ]),
          _c(
            "div",
            { staticStyle: { "text-align": "center" } },
            [
              _c(
                "el-button",
                {
                  staticStyle: { "border-radius": "20px", width: "100px" },
                  attrs: { type: "primary" },
                  on: {
                    click: function ($event) {
                      _vm.dialogVisible = false
                    },
                  },
                },
                [_vm._v("\n        关闭\n      ")]
              ),
            ],
            1
          ),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }